import { useMemo } from 'react'
import { seesAllOrders, type PublicUserDTO } from '@wf/shared'
import { OrderCard } from '../orders/OrderCard'
import { orderMatchesText } from '../orders/orderSearch'
import { useArchive, useOrdersList } from '../orders/useOrders'

/**
 * Globale Auftragssuche, in die Übersicht gefaltet (ersetzt den früheren eigenen „Suche"-Reiter): durchsucht
 * ALLE Aufträge — aktiv und archiviert — nach Kennzeichen, Fahrzeug, Kunde oder Nummer (gleicher Treffer-
 * Helfer wie die Board-Suche). Das Archiv wird nur geladen, während wirklich gesucht wird (Komponente ist
 * nur dann gemountet).
 */
export function OverviewSearchResults({ query, user }: { query: string; user: PublicUserDTO }) {
  const active = useOrdersList()
  // Archiv nur laden, wenn die Rolle es serverseitig sehen darf (GET /orders/archive ist seesAllOrders-
  // geschützt) — sonst feuerte jede Eingabe einen 403. Wer das Archiv nicht darf, durchsucht seine aktiven
  // Aufträge (die der Server ohnehin auf die eigenen eingrenzt).
  const archive = useArchive(seesAllOrders(user))

  const q = query.trim().toLowerCase()
  const results = useMemo(() => {
    if (!q) return []
    const all = [...(active.data?.orders ?? []), ...(archive.data?.orders ?? [])]
    return all.filter((order) => orderMatchesText(order, q))
  }, [active.data, archive.data, q])

  if (q === '') return null

  return results.length === 0 ? (
    <div className="wf-empty">
      <div className="wf-empty__title">Keine Treffer</div>
      <div className="wf-empty__text">Andere Suche versuchen.</div>
    </div>
  ) : (
    <>
      <div className="wf-sectionhead">
        <h3>Treffer</h3>
        <span className="wf-count">{results.length}</span>
      </div>
      <div className="wf-cardgrid">
        {results.map((order) => (
          <OrderCard key={order.id} order={order} />
        ))}
      </div>
    </>
  )
}
